import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PaymentService } from '../payment.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { EntryDictionary, LogInType } from '@generativ/ms-student-types';
import { ContentfulService } from '../../../shared/contentful.service';
import { MarkdownModule } from 'ngx-markdown';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap/tooltip';
import { StripeCardComponent } from '../../../shared/stripe-card/stripe-card.component';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MarkdownModule, NgbTooltip, StripeCardComponent]
})
export class PaymentComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  loading = true;
  hasStripeId: boolean;
  content: LogInType;
  isAgreeToUserAgreement = false;

  constructor(
    private readonly paymentService: PaymentService,
    private readonly authService: AuthService,
    private readonly contentfulService: ContentfulService,
    private router: Router
  ) {
    this.contentfulService.getStudentEntry(EntryDictionary.LogIn.logIn).then(
      (entry) => {
        this.content = new LogInType(entry);
        this.loading = false;
      },
    );
  }

  async ngOnInit(): Promise<void> {
    // If user is authenticated redirect to home
    if (this.authService.isAuthenticated() && !!this.authService.currentStudent.stripeId
      && await this.paymentService.checkSubscriptionStatus()) {
      this.router.navigate(['/']);
    }
    this.hasStripeId = !!this.authService.currentStudent.stripeId;
    this.paymentService.updateUserAgreementStatus(false);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  switchUsersAgreement(event) {
    this.paymentService.updateUserAgreementStatus(event.target.checked);
  }

  checkout(tokenReadyData: any) {
    this.loading = true;
    this.subscriptions.add(this.paymentService.checkout(tokenReadyData.token.id, tokenReadyData.nameOnCard)
      .subscribe(res => {
        this.paymentService.status = null;
        this.authService.setCurrentStudent(res);
        this.router.navigate(['/']);
      }, () => {
        this.loading = false;
      }));
  }


  logout(): void {
    this.loading = true;
    this.authService.logout();
  }
}
